// src/lib/navigationGuard.ts

/**
 * Guard global para interceptar navegaciones PROGRAMÁTICAS (navigate(to)
 * llamado directamente desde código, no desde un click en <a>).
 *
 * useUnsavedChanges ya intercepta clics en <a>/<NavLink> a nivel de
 * documento, pero cosas como el tab bar inferior móvil (que llama a
 * navigate() manualmente tras un gesto de arrastre) no pasan por ahí.
 * Este módulo permite que la página activa con cambios sin guardar
 * "avise" a cualquier componente que quiera navegar por su cuenta.
 *
 * Solo puede haber un guard activo a la vez (la página montada actualmente).
 */

interface Guard {
  isActive: () => boolean;
  requestLeave: (to: string) => void;
}

let currentGuard: Guard | null = null;

export function registerNavigationGuard(guard: Guard): () => void {
  currentGuard = guard;
  return () => {
    if (currentGuard === guard) {
      currentGuard = null;
    }
  };
}

/**
 * Llamar antes de cualquier navigate() programático (ej. tab bar móvil).
 * Devuelve true si la navegación fue INTERCEPTADA (no debes navegar tú
 * mismo; el diálogo se encargará de hacerlo si el usuario confirma).
 * Devuelve false si no hay cambios pendientes y puedes navegar con normalidad.
 */
export function guardNavigate(to: string): boolean {
  if (currentGuard && currentGuard.isActive()) {
    currentGuard.requestLeave(to);
    return true;
  }
  return false;
}